/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_ExpiredInputs */

const en_auth_error_expired = /** @type {(inputs: Auth_Error_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That sign-in took too long and expired. Starting again should work.`)
};

const es_auth_error_expired = /** @type {(inputs: Auth_Error_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El inicio de sesión tardó demasiado y expiró. Volver a intentarlo debería funcionar.`)
};

/**
* | output |
* | --- |
* | "That sign-in took too long and expired. Starting again should work." |
*
* @param {Auth_Error_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_expired = /** @type {((inputs?: Auth_Error_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_expired(inputs)
	return en_auth_error_expired(inputs)
});